import {Calendar} from "primereact/calendar";
import {useSelector} from "react-redux";

import {format, parseISO} from "date-fns";

import {useRevaTranslation} from "../../hooks/languageHooks";
import {selectAssociatedOutputParamOutputCurried} from "../../redux/objectParametersSelectors";
import {formatIsoDay} from "../../util/dateUtil";
import ParameterFieldContainer from "./ParameterFieldContainer";
import {getResourceColor, useInputParameterDef} from "./paramHooks";

export default function ParameterInputDate({
    parameter,
    parameterType,
    label,
    id,
    parameter_details_def,
    associatedOutputParam,
}) {
    const {t, language} = useRevaTranslation();

    const parameterData = useInputParameterDef(parameter, parameter_details_def);

    const eventToValueMapper = (e) => {
        const newDate = e.target.value;
        if (!newDate) {
            // #17901 benötigte Parameter Eingaben dürfen nicht explizit auf leer (e.g. empty) gesetzt werden
            const emptyValue = parameterData?.required === true ? null : "empty";
            return {value: emptyValue};
        }
        // Value kommt vom Calendar-Input als Date Objekt, wird in der API aber als ISO-Date (YYYY-MM-DD) benötigt
        return {value: format(newDate, "yyyy-MM-dd") || null};
    };

    const associatedOutputParamValue = useSelector(selectAssociatedOutputParamOutputCurried(associatedOutputParam));

    if (!parameterData) return null;

    const valueWrapper = (value) => {
        if (!value) return null;

        // Value wird intern als ISO-Date (YYYY-MM-DD) vorgehalten, der Calendar will ihn aber als Date Objekt
        return parseISO(value);
    };

    const wrappedPlaceholder = associatedOutputParamValue
        ? `${t("object.associatedOutputParamPrefix")} ${formatIsoDay(String(associatedOutputParamValue), language)}`
        : undefined;

    return (
        <ParameterFieldContainer
            id={id}
            label={label}
            parameter={parameter}
            parameterType={parameterType}
            parameter_details_def={parameter_details_def}
            showDescription={true}
            noInputGroup
            hasAssociatedOutputParam={!!associatedOutputParam}
            associatedOutputParamValue={associatedOutputParamValue}
            eventToValueMapper={eventToValueMapper}
            renderControl={({className, onChange, value, activeParameterType, hasConflict, disabled}) => {
                const wrappedValue = valueWrapper(value);
                const color = getResourceColor(activeParameterType, hasConflict);

                return (
                    <Calendar
                        id={id}
                        className={`w-full ${parameter}`}
                        inputClassName={`text-${color} ${className} text-right ${
                            associatedOutputParamValue ? `indication-filled-placeholder` : ""
                        }`}
                        pt={{
                            dropdownButton: {
                                root: {
                                    className: "p-button-sm",
                                },
                            },
                        }}
                        value={wrappedValue}
                        onChange={(e) => (e.target.value ? onChange(e) : null)}
                        disabled={disabled}
                        selectionMode="single"
                        locale={language}
                        placeholder={wrappedPlaceholder}
                        showIcon
                        showButtonBar={true}
                        data-pr-position="top"
                    />
                );
            }}
        />
    );
}
